import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

const FedexRateOption = ({ rate, price, setPrice, setIsScheduled, setIsExpedited, setIsSuperExpedited, setIsLTL, setIsProceeded, setFedexSelection, setIsFedex }) => {
  return (
    <FormGroup check className="form-check-radio" id={'shipment-price'}>
      <Label check>
        <Input
          required
          type="radio"
          name="exampleRadio3"
          value={rate.priceMarkup}
          id={`fedex-${rate.serviceName}`}
          onClick={() => {
            setIsFedex(true);
            setFedexSelection({
              service_type: rate.serviceType,
              packaging_type: rate.packagingType,
              service_name: rate.serviceName,
              price: rate.price,
              delivery_date: rate.deliveryDate,
              price_markup: rate.priceMarkup
            });
            setIsScheduled(false);
            setIsExpedited(false);
            setIsSuperExpedited(false);
            setPrice(rate.priceMarkup);
            setIsLTL(false);
            // priceChoice(standardPrice, expeditedPrice, superExpeditedPrice);
            setIsProceeded(true);
          }}
          checked={price === rate.priceMarkup}
        />
        <span className="form-check-sign" /> {rate.serviceName}:<div style={{ color: '#f7941d' }}>${parseFloat(rate.priceMarkup).toFixed(2)}</div>
        (Estimated Delivery: <span style={{ color: '#f7941d' }}>{new Date(rate.deliveryDate).toLocaleString()}</span>)
      </Label>
    </FormGroup>
  );
};

export default FedexRateOption;
